import "./App.css";
import { Routes, Route } from "react-router-dom";
import Home from "./components/Pages/Home/home";
import Album from "./components/Pages/Album/album";
import Project from "./components/Pages/Project/project";
import Trivia from "./components/Pages/Trivia/trivia";
import Header from "./components/Layout/Header/header";
import Footer from "./components/Layout/Footer/footer";
import Sidebar from "./components/Layout/Sidebar/sidebar";
import LoginPage from "./components/Pages/loginPage";
import RegisterPage from "./components/Pages/registerPage";
import Logout from "./components/Auth/logout";
import NotFound from "./components/Pages/404";

function App() {
  return (
    <div className="App">
      <Sidebar />
      <main>
      <Header />
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/proyecto" element={<Project />} />
          <Route path="/album" element={<Album />} />
          <Route path="/trivia" element={<Trivia />} />
          <Route path="/login" element={<LoginPage />} />
          <Route path="/logout" element={<Logout />} />
          <Route path="/registrarse" element={<RegisterPage />} />
          <Route path="/404" component={<NotFound />} />
          <Route path="*" element={<NotFound />} />
        </Routes>
      </main>
      <Footer />
    </div>
  );
}

export default App;
